import ReactTooltip from "react-tooltip";
import Division from "../../../components/Division";
import Header from "../../../components/Header";
import Lateral from "../../../components/Lateral";
import { FaCog } from "react-icons/fa";
import { useEffect, useState } from "react";
import Title from "../../../components/Title";
import api from "../../../config";
import { format } from "date-fns";
import download from "downloadjs";
import Select from "react-select";
import './index.css';
import { toast } from "react-toastify";
import { showMessageError } from "../../../classes/functions";
import { customStyleSelect } from "../../../classes/consts";

export default function Logs(){
    const [carrying, setCarrying] = useState(false);
    const [carryingExcel, setCarryingExcel] = useState(false);
    const [logType, setLogType] = useState([]);
    const [filters, setFilters] = useState({
        logName: "",
        logUrl: "",
        dataDe: "",
        dataAte: ""
    });
    
    function convertDateToBrazilianFormatWithTrace(data){
        let splittedData = data.split('-');

        return splittedData[0] ? `${splittedData[2]}-${splittedData[1]}-${splittedData[0]}` : "";
    }

    function printLogs(){
        let params = `?data_de=${convertDateToBrazilianFormatWithTrace(filters.dataDe)}&data_ate=${convertDateToBrazilianFormatWithTrace(filters.dataAte)}`;

        setCarryingExcel(true);
        
        api
        .get(`${filters.logUrl}${params}`, {responseType: 'blob'})
        .then((response) => {
           const content = response.headers['content-type'];

           const dateAndHour = new Date();
           const formatedDateAndHour = format(dateAndHour, 'dd/MM/yyyy HH:mm:ss');
          
           download(response.data, `LOG_${filters.logName} ${formatedDateAndHour}.xlsx`, content);

           setCarryingExcel(false);
        })
        .catch((error) => {
            setCarryingExcel(false);
            
            showMessageError(error.response.data);
            console.log(error);
        });
    }

    function getLogs(){
        api
        .get('/api/logs')
        .then((response) => {
            response.data.options.map((option) => {
                option.value = option;

                return option;
            });

            setLogType(response.data.options);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        getLogs();
    }, []);
 
    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />
            
            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                        <FaCog icon="spinner" className="spinner" />
                    </div>
                </div>
            }
            {!carrying && 
                <div className="content">
                    <Title name="Logs">
                        <button style={{backgroundColor: `${carryingExcel ? '#001fff' : ''}`, width: `${carryingExcel  ? '6.5rem' : ''}`}} onClick={printLogs} className="buttonInsert">
                            {carryingExcel ? 'Imprimindo...' : 'Imprimir'}
                        </button>
                    </Title>
                    <div className="container">
                        <div className="containerGroupData">
                            <h2>Filtros</h2>
                            <hr></hr>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Tipo de log</label>
                                    <Select options={logType} styles={customStyleSelect} onChange={(e) => setFilters((prevState) => ({...prevState, logUrl: e.url, logName: e.label}))} isSearchable />
                                </div>

                                <div className="formDiv">
                                    <label>Data De</label>
                                    <input type='date' style={{height: '37.5px'}} value={filters.dataDe} onChange={(e) => setFilters((prevState) => ({ ...prevState, dataDe: e.target.value}))}/>
                                </div>

                                <div className="formDiv">
                                    <label>Data Até</label>
                                    <input type='date' style={{height: '37.5px'}} value={filters.dataAte} onChange={(e) => setFilters((prevState) => ({...prevState, dataAte: e.target.value}))}/>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
            }
        </div>
    )
}